import type {EditorViewport} from '@EmailMakerReact/email-maker-react.types';

export interface NavLoadingSkeletonProps {
  editorViewport: EditorViewport;
}

export const CONTROL_HEIGHT = 36;

export const FILE_WIDTH = 54;

export const UNDO_REDO_WIDTH = 84;

export const SAVE_WIDTH = 120;

export const HELP_WIDTH = 40;

export const PREVIEW_WIDTH = 105;

export const EXPORT_WIDTH = 99;

export const SEND_WIDTH = 86;

export const PUBLISH_OPTIONS_WIDTH = 40;

export const MOBILE_ICON_BRICK = 40;
